module.exports = __webpack_public_path__ + "img/logo_instagram.ef5f5f59.png";